import React from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const RegisterModal = ({ show, handleClose, data, type }) => {
  const { t } = useTranslation();
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{t(type)}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div dangerouslySetInnerHTML={{ __html: data }}></div>
      </Modal.Body>
    </Modal>
  );
};

export default RegisterModal;
